exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-2[data-v-01719826]{margin-bottom:20px}.mt-2[data-v-01719826]{margin-top:20px}.vertical-center-modal[data-v-01719826]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.vertical-center-modal .ivu-modal[data-v-01719826]{top:0}.el-carousel[data-v-01719826]{overflow:hidden}.wysiwyg[data-v-01719826]{border:2px solid #e2e7ee;border-radius:10px;overflow:hidden}.wysiwyg.red-hover[data-v-01719826]{border:2px solid #fb202d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01719826","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/fundraisers/components/show/FundraiserUpdates.vue
// module id = 218
// module chunks = 0